<template>
  <div>
    <br />
    <div class="row align-items-end">
      <div class="col-3 my-3">
        <label for="">Client</label>
        <vue-select
          :options="customers"
          v-model="payment.customer_reference"
          @input="getCustomerSalesUnpaid(payment.customer_reference)"
          labelColumn="society"
          valueColumn="reference"
        />
        <!-- <select class="form-select" v-model="payment.customer_reference"
          @change="getCustomerSalesUnpaid(payment.customer_reference)">
          <option value="" default></option>
          <option v-for="(customer, index) in customers" :key="index++" :value="customer.reference">
            <div class="row justify-content-between">
              <span class="col-auto">
                {{ customer.fullName }}
              </span>
              <span class="col-auto">
                {{ customer.society }}
              </span>
            </div>
          </option>
        </select> -->
        <div
          v-if="payment.customer_reference && totalUnpaidAmount > 0"
          class="mt-2"
        >
          <small class="text-danger fw-bold">
            Total impayé : {{ parseFloat(totalUnpaidAmount).toFixed(2) }} DH
          </small>
        </div>
      </div>

      <div class="col-6 my-3">
        <label for=""> Factures impayées </label>
        <select class="form-select" v-model="payment.sale_reference">
          <option value="" default></option>
          <option
            v-for="(sale, index) in sales"
            :key="index"
            :value="sale.reference"
            :class="
              sale.totalPriceTTC !== sale.amountUnpaid
                ? 'text-danger fw-bold'
                : ''
            "
          >
            Nº {{ sale.reference }} / {{ sale.date }} /
            {{ sale.totalPriceTTC }} DH / Reste : {{ sale.amountUnpaid }} DH
          </option>
        </select>
      </div>

      <div class="col my-3">
        <label for=" "> </label>
        <button @click="setUnpaidAmount()" class="btn btn-secondary">
          Remplir
        </button>
      </div>
      <div class="col-2 my-3">
        <label for="">Montant</label>
        <input type="text" v-model="payment.amount" class="form-control" />
      </div>

      <div class="col-3 my-3">
        <label for="">Date</label>
        <input type="date" v-model="payment.date" class="form-control" />
      </div>

      <div class="col-auto my-3">
        <label for=""> </label>
        <button @click="selectTodayDate" class="btn btn-secondary">
          Date d'aujourd'hui
        </button>
      </div>
      <div class="col-3 my-3">
        <label for="">Mode de paiement</label>
        <select v-model="payment.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div>

      <div
        v-if="
          payment.paymentMethod == 'Chèque' || payment.paymentMethod == 'Effet'
        "
        class="col-3 my-3"
      >
        <label for="">Numéro de chèque</label>
        <input type="text" v-model="payment.checkNumber" class="form-control" />
      </div>

      <div
        v-if="payment.paymentMethod == 'Virement bancaire'"
        class="col-3 my-3"
      >
        <label for="">Numéro de virement bancaire</label>
        <input
          type="text"
          v-model="payment.bankTransferNumber"
          class="form-control"
        />
      </div>

      <div class="col-12 my-3">
        <label for="">Remarques</label>
        <textarea class="form-control" cols="30" rows="3"></textarea>
      </div>
    </div>
    <br />
    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(payment)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      payment: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentMethod: "Espèce",
      },
    };
  },
  computed: {
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("sale", { sales: "getSales" }),
    totalUnpaidAmount() {
      if (!this.sales || this.sales.length === 0) {
        return 0;
      }
      return this.sales.reduce((total, sale) => {
        const unpaid = parseFloat(sale.amountUnpaid) || 0;
        return total + unpaid;
      }, 0);
    },
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("payment/store", data);
    },
    async getCustomerSalesUnpaid(customer_reference) {
      this.payment.sale_reference = "";
      this.payment.amount = "";
      this.$store.dispatch("sale/getCustomerSalesUnpaid", customer_reference);
    },
    async selectTodayDate() {
      this.payment.date = new Date(
        new Date().setFullYear(new Date().getFullYear())
      )
        .toLocaleString("en-CA")
        .split(",")[0];
    },
    setUnpaidAmount() {
      const selectedSale = this.sales.find(
        (sale) => sale.reference === this.payment.sale_reference
      );
      if (selectedSale) {
        this.payment.amount = selectedSale.amountUnpaid;
      } else {
        this.payment.amount = this.totalUnpaidAmount;
      }
    },
  },
  beforeMount() {
    this.$store.dispatch("customer/getAll");
  },
};
</script>
